import { render, staticRenderFns } from "./VendorPicker.vue?vue&type=template&id=d8101560&"
import script from "./VendorPicker.vue?vue&type=script&lang=js&"
export * from "./VendorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports